// Compatibility export: the runtime token lives in the physically public
// package so public bootstrap consumers do not import the broad core barrel.
export { APP_INFO, type IAppInfo, type SneatApp } from '@sneat/core-public';
export {
  BUILD_INFO,
  type IBuildInfo,
  provideBuildInfo,
} from '@sneat/core-public';
